/**
 * Feature Slider Component
 * Uses Owl Carousel 2 to create feature sliders with previews
 * Handles 3 or fewer items by centering without loop, enables loop/autoplay for larger screens
 */
(function() {
    // Component implementation
    const FeatureSlider = {
        init: function() {
            const $ = jQuery;
            
            // Find all feature slider components on the page
            $('.component__feature_slider').each(function() {
                const $container = $(this).find('.owl-carousel'); // Target the slider container
                const containerId = $container.attr('id');
                
                // Initialize this specific feature slider
                FeatureSlider.initSlider($container, containerId);
            });
        },
        
        initSlider: function($container, containerId) {
            const $ = jQuery;
            
            // Count the number of items in this slider
            const itemCount = $container.children().not('.cloned').length;
            const hasExactlyThree = itemCount === 3;
            const hasTwoOrLess = itemCount <= 2;
            
            // Determine breakpoint where we enable loop and autoplay (you can adjust this)
            const loopBreakpoint = 1280; // Enable loop/autoplay at 1280px and above
            
            // Get current screen width
            const screenWidth = $(window).width();
            
            // If exactly 3 items, never loop or autoplay
            // If 2 or less, enable normal behavior
            // If more than 3 items, only loop/autoplay on larger screens
            let shouldLoop, shouldAutoplay;
            if (hasExactlyThree) {
                shouldLoop = false;
                shouldAutoplay = false;
            } else if (hasTwoOrLess) {
                shouldLoop = true; // Normal behavior for 2 or less
                shouldAutoplay = true;
            } else {
                shouldLoop = screenWidth >= loopBreakpoint;
                shouldAutoplay = screenWidth >= loopBreakpoint;
            }
            
            // Initialize this specific Owl Carousel instance
            $container.owlCarousel({
                margin: 0,
                center: hasExactlyThree ? true : false, // Only center for exactly 3 items
                items: 3,
                autoHeight: false,
                nav: false,
                dots: false,
                loop: shouldLoop,
                autoplay: shouldAutoplay,
                autoplayTimeout: 4000, // 4 seconds between slides
                autoplayHoverPause: true, // Pause on hover
                mouseDrag: hasExactlyThree ? false : true, // Only disable dragging for exactly 3 items
                touchDrag: hasExactlyThree ? false : true, // Only disable touch dragging for exactly 3 items
                pullDrag: hasExactlyThree ? false : true, // Only disable pull dragging for exactly 3 items
                startPosition: hasExactlyThree ? 1 : 0, // Start from center item only if exactly 3 items
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 15,
                        loop: true,
                        autoplay: true,
                        center: true,
                        pullDrag: true,
                        mouseDrag: true, 
                        touchDrag: true, 
                    },
                    640: {
                        items: 1,
                        stagePadding: 100,
                        loop: true,
                        autoplay: true,
                        center: true,
                        pullDrag: true,
                        mouseDrag: true, 
                        touchDrag: true, 
                    },
                    980: {
                        items: 2,
                        stagePadding: 100,
                        loop: true,
                        autoplay: true,
                        center: false,
                        pullDrag: true,
                        mouseDrag: true, 
                        touchDrag: true, 
                    },
                    1280: {
                        items: 3,
                        stagePadding: 50,
                        center: hasExactlyThree ? true : false, // Only center for exactly 3 items
                        loop: shouldLoop,
                        autoplay: shouldAutoplay,
                        mouseDrag: hasExactlyThree ? false : true,
                        touchDrag: hasExactlyThree ? false : true,
                    }
                }
            });
        }
    };

    // Initialize on document ready
    jQuery(document).ready(function() {
        FeatureSlider.init();
    });
    
    // Make available globally if needed
    window.FeatureSlider = FeatureSlider;
})();